// Unpublished Work © 2024 Deere & Company.
import {
  ExcelIcon,
  OneNoteIcon,
  PDFIcon,
  PowerPointIcon,
  WordIcon,
} from "@deere/fuel-react";
import ImageIcon from "@mui/icons-material/Image";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import { SvgIconProps } from "@mui/material";
import { FC } from "react";

type IconInfo = {
  icon: FC<SvgIconProps>;
  extensions?: string[];
  color: string;
};

function getIcon(fileName: string): IconInfo {
  const extension = fileName.split(".").pop();
  const iconInfo = iconMap.find((item) =>
    item.extensions?.includes(extension ?? "")
  );
  return (
    iconInfo ?? {
      icon: FileIcon,
      color: "#666666",
    }
  );
}

function getFileTypeIcon(name: string) {
  const iconInfo = getIcon(name);
  const Icon = iconInfo.icon;
  return (
    <Icon
      fontSize="small"
      sx={{
        verticalAlign: "middle",
        color: iconInfo.color,
      }}
    />
  );
}

const iconMap: IconInfo[] = [
  {
    icon: PDFIcon,
    extensions: ["pdf"],
    color: "#F00000",
  },
  {
    icon: OneNoteIcon,
    extensions: ["one"],
    color: "#7C3876",
  },
  {
    icon: PowerPointIcon,
    color: "#D24625",
    extensions: ["ppt", "pptx"],
  },
  {
    icon: WordIcon,
    color: "#2A5699",
    extensions: ["doc", "docx", "odt", "txt", "html"],
  },
  {
    icon: ImageIcon,
    extensions: ["apng", "avif ", "gif", "jpeg", "jpg", "png", "svg", "webp"],
    color: "#666666",
  },
  {
    icon: ExcelIcon,
    color: "#11764B",
    extensions: ["xls", "xlsx", "xlsm", "xlsb", "csv"],
  },
];

export default getFileTypeIcon;
